import type { JSX } from 'react';
import { ChatUserAvatar, useAuth, type ChatAvatarUser } from '@footsteps/shared';

export const WozUserAvatar = (): JSX.Element => {
  const { user } = useAuth();

  const avatarUser: ChatAvatarUser = {
    email: user?.email,
    displayName: (user?.user_metadata?.full_name as string) ?? undefined,
    isAnonymous: user?.is_anonymous ?? true,
  };

  return <ChatUserAvatar user={avatarUser} />;
};
